<!-- eslint-disable-next-line agentic/no-single-template-wrapper -- NgIcon is the SVG renderer and owns QpxIcon presentation, not a layout wrapper. -->
<ng-icon
    qpx
    [svg]="svg()"
    [size]="resolvedSize()"
    [strokeWidth]="strokeWidth()"
    [color]="resolvedColor()"
/>
